import Footer from "../../components/Footer";
import Header from "../../components/Header";
import PrimeEVManagement from "../../components/Service/Subservice/prime-ev-management";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function PrimeManagementPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Proactive Restoration and Integrated Management of EV Stations"}/>
            <PrimeEVManagement/>
            <Footer/>
        </>
    )
}